export const POLLING_INTERVAL_CAMPAIGN_LIST_INITIAL = 3000;
export const POLLING_INTERVAL_CAMPAIGN_LIST_CONTINIOUS = 1000;

export const POLLING_INTERVAL_CONVERSATION = 2000;
export const POLLING_INTERVAL_FILE_STATUS = 5000;
